import http from "@/utils/httpService";

export function OrgTreeApi() {
  return http.Axios({
    url: "/web/org/tree",
    method: "get"
  });
}

export function OrgPageApi(data) {
  return http.Axios({
    url: "/web/org/page",
    method: "get",
    params: data
  });
}

export function OrgDetailApi(id) {
  return http.Axios({
    url: "/web/org/detail/" + id,
    method: "get"
  });
}
export function OrgDeleteApi(id) {
  return http.Axios({
    url: "/web/org/delete/" + id,
    method: "get"
  });
}

export function OrgUpdateApi(data) {
  return http.Axios({
    url: "/web/org/save",
    method: "post",
    data: data
  });
}

export function OrgSaveApi(data) {
  return http.Axios({
    url: "/web/org/save",
    method: "post",
    data: data
  });
}

export function caseInfoListApi(data) {
  return http.Axios({
    url: "/web/caseInfo/home/" + data.type,
    method: "get",
    params: { id: data.id ? data.id : "0" }
  });
}
// orgUpdateStateApi

export function orgUpdateStateApi(state, data) {
  return http.Axios({
    url: "/web/org/changeState/" + state,
    method: "post",
    data: data
  });
}

export function treeByCompanyIdApi() {
  return http.Axios({
    url: "/web/org/treeByCompanyId",
    method: "get"
  });
}

//获取作业机构一级数据
export function orgListApi(data) {
  return http.Axios({
    url: "/web/org/list",
    method: "post",
    data: data
  });
}
